import * as types from "./actionTypes";

export const getListRequest = (paginate=false) => {
  return {
    type: types.CONTACT_LIST_REQUEST,
    paginate
  };
};
export const getListSuccess = data => {
  return {
    type: types.CONTACT_LIST_SUCCESS,
    payLoad: data
  };
};
export const getListFailure = data => {
  return {
    type: types.CONTACT_LIST_FAILURE
  };
};

export const clearLastItem = () => {
  return {
    type: types.CONTACT_CLEAR_LAST_ITEM
  };
};

export const getAllRequest = () => {
  return {
    type: types.CONTACT_ALL_REQUEST
  };
};
export const getAllSuccess = data => {
  return {
    type: types.CONTACT_ALL_SUCCESS,
    payLoad: data
  };
};
export const getAllFailure = data => {
  return {
    type: types.CONTACT_ALL_FAILURE
  };
};

export const showRequest = id => {
  return {
    type: types.CONTACT_SHOW_REQUEST,
    id: id
  };
};
export const showSuccess = data => {
  return {
    type: types.CONTACT_SHOW_SUCCESS,
    payLoad: data
  };
};
export const showFailure = data => {
  return {
    type: types.CONTACT_SHOW_FAILURE
  };
};

export const storeRequest = data => {
  return {
    type: types.CONTACT_STORE_REQUEST,
    data: data
  };
};

export const storeSuccess = data => {
  return {
    type: types.CONTACT_STORE_SUCCESS,
    payLoad: data
  };
};
export const storeFailure = () => {
  return {
    type: types.CONTACT_STORE_FAILURE
  };
};

export const updateRequest = (id, data) => {
  return {
    type: types.CONTACT_UPDATE_REQUEST,
    id: id,
    data: data
  };
};
export const updateSuccess = data => {
  return {
    type: types.CONTACT_UPDATE_SUCCESS,
    payLoad: data
  };
};
export const updateFailure = () => {
  return {
    type: types.CONTACT_UPDATE_FAILURE
  };
};

export const addFavoriteRequest = (id, status) => {
  return {
    type: types.CONTACT_ADD_FAVORITE_REQUEST,
    id,
    status
  };
};
export const addFavoriteSuccess = data => {
  return {
    type: types.CONTACT_ADD_FAVORITE_SUCCESS,
    payLoad: data
  };
};
export const addFavoriteFailure = () => {
  return {
    type: types.CONTACT_ADD_FAVORITE_FAILURE
  };
};

export const removeRequest = data => {
  return {
    type: types.CONTACT_REMOVE_REQUEST,
    data: data
  };
};
export const removeSuccess = (id, data) => {
  return {
    type: types.CONTACT_REMOVE_SUCCESS,
    payLoad: {
      id: id,
      data: data
    }
  };
};
export const removeFailure = () => {
  return {
    type: types.CONTACT_REMOVE_FAILURE
  };
};
